import React from "react"
import ReactDOM from "react-dom/client"
import { I18nextProvider } from "react-i18next"
import App from "./App"
import i18n from "./utils/i18n"
import "./index.css"
import * as serviceWorkerRegistration from "./serviceWorkerRegistration"

import { store, persistor } from "./redux/store"
import { Provider } from "react-redux"
import { PersistGate } from "redux-persist/integration/react"

const root = ReactDOM.createRoot(document.getElementById("root"))
root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <I18nextProvider i18n={i18n}>
        <App />
      </I18nextProvider>
    </PersistGate>
  </Provider>
  // </React.StrictMode>
)

serviceWorkerRegistration.registerMainSW()
serviceWorkerRegistration.registerFirebaseSW()
